<template>
  <v-container fluid>
    <v-row v-if="isLoading">
      <v-col>
        <loading-spinner></loading-spinner>
      </v-col>
    </v-row>
    <v-row class="ml-10 mr-10" v-else>
      <v-col cols="12" class="d-flex flex-column">
        <h3>{{ $t("title.select_journal") }}</h3>
        <p>{{ $t("txt.select_journal_description") }}</p>
      </v-col>
      <v-col
        cols="12"
        xl="4"
        lg="6"
        md="6"
        sm="12"
        xs="12"
        v-for="journal in journals"
        :key="journal.idx"
      >
        <v-card class="rounded-lg" hover @click="selectJournal(journal.idx)">
          <v-card-title>
            <v-sheet
              width="32"
              height="32"
              class="d-flex align-center justify-center rounded-lg mr-2 mb-2 mt-2"
              color="green darken-2"
            >
              <v-icon small dark>mdi-book-open-variant</v-icon>
            </v-sheet>
            <div>
              <h6 class="text-body-1 font-weight-medium">
                {{ journal.title }}
              </h6>
              <p class="text-body-2 font-weight-light mb-0">
                {{ journal.title_eng }}
              </p>
            </div>
          </v-card-title>
          <v-card-text>
            <hr class="mb-2" />
            <p class="text-caption">
              {{ journal.year }} Vol.{{ journal.volume }} No.{{ journal.issue }}
            </p>
            <p class="text-caption">{{ journal.description }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import CustomButton from '@/components/common/buttons/CustomButton.vue';
import LoadingSpinner from "@/components/common/Spinners/LoadingSpinner.vue";
import { journalApi } from "@/api/api";

export default {
  components: {
    // CustomButton,
    LoadingSpinner,
  },
  data() {
    return {
      isLoading: false,
      selectedJournal: null,
      journals: [],
    };
  },
  methods: {
    selectJournal(idx) {
      this.selectedJournal = idx;
      this.toAgreement();
    },
    toAgreement() {
      if (!this.selectedJournal) {
        this.notifyVue({
          message: this.$t("alert.select_journal"),
          style: "danger",
        });
        return;
      }
      this.$router.push({
        name: "submission-agreement",
        params: { journalIdx: this.selectedJournal },
      });
    },
    async fetchJournalsForSubmissions() {
      try {
        this.isLoading = true;
        const response = await journalApi.showAllForSubmissions();

        if (response.status === 200) {
          this.journals = response.data.response;
        } else {
          this.notifyVue({
            message: this.$t("alert.failed_request"),
            style: "danger",
          });
        }
      } catch (error) {
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
      } finally {
        this.isLoading = false;
      }
    },
    /* ****************************************************************************************
     * 알럿
     * ****************************************************************************************/
    notifyVue({
      vertical = "top",
      horizontal = "right",
      message = "",
      style = "primary",
      icon = "priority_high",
    } = {}) {
      this.$notify({
        timeout: 8000,
        message: message,
        icon: icon,
        type: style,
        horizontalAlign: horizontal,
        verticalAlign: vertical,
      });
    },
  },
  mounted() {
    this.fetchJournalsForSubmissions();
  },
};
</script>
